import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../../../constants/general-constants";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default function UtilisationChartBarBreakdownWorkstation({}){
	
	const chartId1 = "utilisationchartbarbreakdown1";
	
	const chartData1 = [
		{label:'A1', occupied:"30", signsoflife:"20", unused:"10"},
		{label:'A2', occupied:"10", signsoflife:"10", unused:"40"},
		{label:'A3', occupied:"30", signsoflife:"0", unused:"30"},
		{label:'A4', occupied:"40", signsoflife:"10", unused:"10"},
		{label:'B1', occupied:"10", signsoflife:"0", unused:"10"},
		{label:'B2', occupied:"30", signsoflife:"0", unused:"10"},
		{label:'B3', occupied:"30", signsoflife:"0", unused:"30"},
		{label:'B4', occupied:"40", signsoflife:"10", unused:"10"},
		{label:'C1', occupied:"10", signsoflife:"0", unused:"10"},
		{label:'C2', occupied:"30", signsoflife:"0", unused:"10"}
		
	];
	
	const graphs1 = [
		{title:"Occupied", keyColumn:"occupied", color:"darkblue"},
		{title:"Signs Of Life", keyColumn:"signsoflife", color:"lightblue"},
		{title:"Unused", keyColumn:"unused", color:"#eee"}
	];
	
	
	useEffect(() => {
		let categoryKey = "label";
		
		let x = am4core.create(chartId1, am4charts.XYChart);
		x.fontSize = 10;
    x.fill='black';
    x.strokeAlpha=0;
		x.paddingTop = 0;
		x.paddingRight = 0;
		x.paddingLeft = 0;
		x.paddingBottom = 0;
		let categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
		categoryAxis.renderer.grid.template.strokeOpacity = 0;
		categoryAxis.renderer.labels.template.strokeOpacity=0;
		categoryAxis.renderer.labels.template.fillOpacity=1;
		categoryAxis.dataFields.category=categoryKey;	
		categoryAxis.renderer.labels.template.rotation=0;
		categoryAxis.renderer.minGridDistance = 15;
		categoryAxis.renderer.inversed=true;
		categoryAxis.renderer.labels.template.horizontalCenter = "right";
		
		let valueAxis = x.xAxes.push(new am4charts.ValueAxis());
		valueAxis.renderer.grid.template.strokeOpacity = 0;
		valueAxis.renderer.labels.template.strokeOpacity=0;
		valueAxis.renderer.labels.template.fillOpacity=0;
		
		for(let i=0; i<graphs1.length; i++){
	 		let series = x.series.push(new am4charts.ColumnSeries());
	 		series.name = graphs1[i].title;
	    series.dataFields.categoryY = categoryKey;
	    series.dataFields.valueX = graphs1[i].keyColumn;
	    series.fill = graphs1[i].color;
	    series.stroke = graphs1[i].color;
	    series.tooltipText = graphs1[i].title + " ({categoryY}): {valueX}";
  		series.tooltip.label.wrap=true;
  		series.tooltip.label.width=300;
  		series.tooltip.label.fill='black';
  		series.stacked=true;
	  }
	   
	   x.cursor = new am4charts.XYCursor();
	   
			x.data = chartData1;
			chart1.current = x;
	}, [chartData1, graphs1]);
	
	
	
	const chart1 = useRef(null);
	
	
	const thisContainer = {
		display:'flex',
		marginLeft:"20px",
		paddingTop:"20px",
		paddingBottom:"20px",
		width:"calc(100%)",
		height:"100%",
		fontWeight:"bold",
		flexDirection:"column"
	};
	
	
	
	const chartContainer ={ 
		display:"flex",
		width:"100%",
		height:"calc(100% - 80px)"
	};
	
	
	
	const chartContainer1 = {
		display:'flex',
		width:"100%"
	};
	
	
	
	
	
	return (
		<div style={thisContainer}>
			
			<div style={chartContainer}>
				<div style={chartContainer1} id={chartId1}>
			
				</div>
				
			</div>
			
		</div>
	);
}